/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Add_ToInputs */

const en_ui_add_to = /** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add to ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Add to {name}" |
*
* @param {Ui_Add_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ui_add_to = /** @type {((inputs: Ui_Add_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Add_ToInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ui_add_to(inputs)
});